// /api/orders/{terminal_pk}/orders/
import axios from './configAxios';

export const postNewOrderApi = async (terminal_id, requestData) => {
	return await axios.post(`/${terminal_id}/`, requestData);
};
